import { Route } from '@angular/router';

import { TaskListTemplatesComponent } from './task-list-templates.component';
import { TaskListTemplatesListComponent } from './list/list.component';

export const taskListTemplatesRoutes: Route[] = [
  {
    path: '',
    component: TaskListTemplatesComponent,
    children: [
      {
        path: '',
        component: TaskListTemplatesListComponent,
      },
      {
        path: ':id',
        loadChildren: () =>
          import('app/modules/settings/task-list-templates/details/details.module').then(
            (m) => m.TaskListTemplatesDetailsModule,
          ),
      },
    ],
  },
];
